// extracted by mini-css-extract-plugin
export var fadeIn = "_i4-1";
export var modalContent = "_i4-3";
export var overlay = "_i4-0";
export var popoverContent = "_i4-2";
export var results = "_i4-5";
export var searchInputWrapper = "_i4-4";